import React from 'react';
import AsyncSelect from 'react-select/async';
import { Label } from 'reactstrap';
import getCssVariable, { THEME_GREY } from 'services/getCssVariable';

// Lower case without accents (é as e), for comparing what is typed with the choices
const foldForSearch = (text: string): string =>
  text.toLocaleLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');

const SearchDropdown = ({
  className,
  disabled,
  id,
  label,
  loadOptions,
  name,
  onChange,
  placeholder,
  required,
  value,
}: {
  className?: string;
  disabled?: boolean;
  id?: string;
  label?: string;
  loadOptions: any;
  name?: string;
  onChange: any;
  placeholder: string;
  required?: boolean;
  value: any;
}): JSX.Element | null => {
  return (
    <>
      {label === undefined ? null : (
        <Label className="label" for={id}>
          {label}
        </Label>
      )}
      <AsyncSelect
        className={`text-field search-field ${className}`}
        // Each word typed anywhere in the choice, in any order, e.g. "kipsi 13" finds
        // "GN13 kipsilevy" (the default wanted the whole text as it was typed). Like the
        // default, the value counts too and the accents do not matter
        filterOption={(
          option: { label: string; value: unknown },
          input: string
        ) => {
          const text = foldForSearch(
            `${option.label ?? ''} ${option.value ?? ''}`
          );
          return foldForSearch(input)
            .split(/\s+/)
            .filter(Boolean)
            .every((word) => text.includes(word));
        }}
        id={id}
        isClearable
        isDisabled={disabled}
        loadOptions={loadOptions}
        // Upwards when there is no room below, e.g. on the last line of the page
        menuPlacement="auto"
        name={name}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        styles={{
          control: (provided, state) =>
            state.isDisabled
              ? {
                  ...provided,
                  backgroundColor: getCssVariable(THEME_GREY),
                }
              : provided,
        }}
        value={value}
      />
    </>
  );
};

export default SearchDropdown;
